import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';

export interface AssociatedUnitsByAge {
  ageTitle: string;
  ageUuid: string;
  ageOrder: number;
  hasChanges: boolean;
  units: Array<{
    uuid: string;
    title: string;
    order: number;
    status: string;
  }>;
}

@Component({
  selector: 'app-associated-units-list',
  templateUrl: './associated-units-list.component.html',
  styleUrls: ['./associated-units-list.component.scss'],
  standalone: true,
  imports: [CommonModule, DragDropModule],
})
export class AssociatedUnitsListComponent implements OnChanges {
  @Input() unitsGroupedByAge: AssociatedUnitsByAge[] = [];
  @Input() parentEntityName: 'Goal' | 'Age' = 'Goal';
  @Output() unitsChanged = new EventEmitter<AssociatedUnitsByAge[]>();
  @Output() hasUnsavedChanges = new EventEmitter<boolean>();

  private originalUnitsOrder: AssociatedUnitsByAge[] = [];

  ngOnChanges(changes: SimpleChanges) {
    // Store original order when input changes
    if (changes['unitsGroupedByAge'] && this.unitsGroupedByAge && this.unitsGroupedByAge.length > 0) {
      // Deep clone to capture the original state
      this.originalUnitsOrder = JSON.parse(JSON.stringify(this.unitsGroupedByAge));
    }
  }

  onUnitDropped(event: CdkDragDrop<any[]>, ageIndex: number) {
    const ageGroup = this.unitsGroupedByAge[ageIndex];
    moveItemInArray(ageGroup.units, event.previousIndex, event.currentIndex);

    // Check if order has changed from original
    this.checkForUnitOrderChanges();

    // Emit the updated units
    this.unitsChanged.emit(this.unitsGroupedByAge);
  }

  private checkForUnitOrderChanges() {
    let hasAnyChanges = false;

    this.unitsGroupedByAge.forEach((ageGroup, index) => {
      const currentOrder = JSON.stringify(ageGroup.units.map(u => u.uuid));
      const originalOrder = JSON.stringify(this.originalUnitsOrder[index]?.units.map(u => u.uuid) || []);
      ageGroup.hasChanges = currentOrder !== originalOrder;

      if (ageGroup.hasChanges) {
        hasAnyChanges = true;
      }
    });

    this.hasUnsavedChanges.emit(hasAnyChanges);
  }
}
